import React, {PureComponent} from 'react';
import {CSVLink} from 'react-csv';

import './style.scss';
import TableSort from "../../../../components/table/TableSort";
import {connect} from 'react-redux';
import {getListTeamPitchers, ACTIONS_TEAM, converDataPitcher} from '../../../../actions/team-pitchers';
import Loading from '../../../../components/loading';
import {host} from "../../../../environment";


class TeamPitcher extends PureComponent {
    constructor(props) {
        super(props);
        this.count = 0;
        this.state = {
            headerCSV: [],
            idTeam: 0,
            showLoading: false,
            listPitchers: [],
            listCsv: [],
        }
        this.onRedirect = this.onRedirect.bind(this);
    }

    componentDidMount() {
        const headerCSV = this.props.header && this.props.header.map((item) => {
            return item.name;
        })
        this.setState({
            headerCSV: headerCSV
        })
        this.setState({ showLoading: true })
        let id = this.props.match.params.id;
        id && this.setState({ idTeam: id });
        this.props.getListTeamPitchers(id);

    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return !(this.count > 1);
    }

    UNSAFE_componentWillReceiveProps(nextProps)  {
        if (nextProps) {
            if (nextProps.status === ACTIONS_TEAM.GET_INFO_PITCHERS_GAMES_SUCCESS) {
                if(this.count > 1) return;
                this.count += 1;
                if (!nextProps.response) return;
                const data = converDataPitcher(nextProps.response) || [];
                this.props.titleTeamReport(nextProps.response[0].team_id);
                this.setState({
                    listPitchers: data,
                    showLoading: false,
                    listCsv: data.map(item => item.item.map(value => {
                        if(value.text === 0) {
                            return 0;
                        }
                        return value.text || '';
                    })),
                });
                if(nextProps.default_sort) {
                    this.props.header.map(item => {
                        item.default_sort = nextProps.default_sort[item.name_s];
                    })
                }
            }
        }
    }

    onRedirect(id) {
        this.props.history.push('/player/' + id);
    }

    render() {

        const sortConfig = {
            url: `${host.serverTest}api/teams/${this.state.idTeam}/pitchers`,
            type: 'pitcher'
        };
        return (
            <div className="team-pitcher">
                <div className="wrapper" id='team-pitcher'>
                    <div className="block-button">
                        <div className="explain-text">
                            <div>※勝率、防御率、BB/9、K/9、K/BB、WHIPを選択時：規定投球回数を満たしている選手データは</div><div className="orange-text">__</div><div>より上段に表示されます。 </div>
                        </div>
                        <CSVLink className={'csv-download'} headers={this.state.headerCSV} data={this.state.listCsv} filename={'team-pitcher.csv'}>
                            CSVダウンロード
                        </CSVLink>
                    </div>
                    <TableSort
                        teamPitcherResponse = { this.props.response}
                        isFilterCondition= {true}
                        header={this.props.header}
                        showCheckbox={false}
                        showSearch={false}
                        sort={sortConfig}
                        itemOfPage={this.state.listPitchers}
                        isShowOptionTable={false}
                        showPagination={false}
                        defaultValue={'-'}
                        onRowClick={(value) => this.onRedirect(value.id)}
                    />
                </div>
                <Loading show={this.state.showLoading} />
            </div>
        );
    }
}

const mapStateToProps = ({ teams, teamPitcher }) => {
    return {
        header: teams.headerPitcher,
        mockDataPitchingTable: teams.mockDataPitchingTable2,
        response: teamPitcher.response,
        status: teamPitcher.status,
        default_sort: teamPitcher.default_sort,
    };
}

const mapDispatchToProps = dispatch => {
    return {
        getListTeamPitchers: (id) => {
            dispatch(getListTeamPitchers(id))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps, null,{ pure: false })(TeamPitcher);
